import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=edd64e2a"
import script from "../services/policy.js?vue&type=script&lang=js&external"
export * from "../services/policy.js?vue&type=script&lang=js&external"
import style0 from "../assets/css/policy.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports